// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4520a53c","977":"f5af0b7e"}[chunkId] + ".chunk.js";
};